import React from "react";
import { ThemeProvider } from "@material-ui/core/styles";
import theme from "resources/theme";
import Amplify from "aws-amplify";
import { useInterval } from "lib/react/customHooks";
import { Switch, withRouter, Route } from "react-router-dom";
import awsConfig from "aws-exports";
import ForgotPasswordComponent from "app/auth/ForgotPasswordComponent";
import SignInComponent from "app/auth/SignInComponent";
import PrivateRoute from "app/auth/PrivateRoute";
import NavBarComponent from "app/navbar/NavBarComponent";
import { checkTokenExpirationTime } from "lib/session/tokenExpirationTime";
import UsersComponent from "./app/users/UsersComponent";
import CompaniesComponent from "./app/companies/CompaniesComponent";
import AthenaTenantsComponent from "./app/athena_tenants/AthenaTenantsComponent";
// import ApolloTenantsComponent from "./app/apollo_tenants/ApolloTenantsComponent";

const MainComponent = () => {
  useInterval(() => {
    checkTokenExpirationTime();
  }, 60000);
  return (
    <>
      <NavBarComponent />
      <Switch>
        <PrivateRoute exact path={["/", "/users"]} component={UsersComponent} />
        <PrivateRoute exact path="/companies" component={CompaniesComponent} />
        <PrivateRoute
          exact
          path="/athenaTenants"
          component={AthenaTenantsComponent}
        />
        {/* <PrivateRoute
          exact
          path="/apolloTenants"
          component={ApolloTenantsComponent}
        /> */}
      </Switch>
    </>
  );
};

export default withRouter(function App() {
  Amplify.Logger.LOG_LEVEL = "INFO"; // We write INFO level logs throughout app
  Amplify.configure(awsConfig);

  return (
    <div className="app-root">
      <ThemeProvider theme={theme}>
        <Switch>
          <Route exact path="/login" component={SignInComponent} />
          <Route
            exact
            path="/forgotPassword"
            component={ForgotPasswordComponent}
          />
          <PrivateRoute path="/" component={MainComponent} />
        </Switch>
      </ThemeProvider>
    </div>
  );
});
